import { styles } from '../../duck';
import { Flex, MenuItem, Text, Tooltip, useDisclosure } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { Icon } from '@lon/shared/components';
import { StudentAssignmentStatusTransformed } from '@lon/shared/enums';
import { clearQueryCache } from '@lon/shared/utils';
import { ReturnAssignmentModal } from '@lon/suit/components';
import { ReturnAssignmentInterface } from '@lon/suit/types';

const ReturnAssignment: React.FC<ReturnAssignmentInterface> = ({ isLti = false, isMultiple = false, studentsData }) => {
  const { isOpen, onClose, onOpen } = useDisclosure();

  const { t } = useTranslation();
  const isDisabled =
    !isMultiple &&
    studentsData[0].transformedStatus !==
      StudentAssignmentStatusTransformed.Graded &&
    studentsData[0].transformedStatus !==
      StudentAssignmentStatusTransformed.ToBeGraded;

  return (
    <>
      <Tooltip
        isDisabled={isDisabled}
        variant="dark"
        label={
          isMultiple
            ? t('assignments.multipleReturnAssignmentTooltip')
            : t('assignments.singleReturnAssignmentLTITooltip', {
                name: `${studentsData[0]?.firstName} ${studentsData[0]?.lastName}`,
              })
        }
      >
        <MenuItem
          isDisabled={isDisabled}
          onClick={isDisabled ? () => {} : onOpen}
          p={0}
        >
          <Flex flex="1" gap={3} py="2" px="6">
            <Icon name="returnAssignmentOutlined" className={styles.icon} />
            <Text variant="s2">{t('assignments.returnAssignment')}</Text>
          </Flex>
        </MenuItem>
      </Tooltip>
      <ReturnAssignmentModal
        isLti={isLti}
        onClose={onClose}
        isOpen={isOpen}
        isMultiple={isMultiple}
        studentsData={studentsData}
        onCompleted={() => {
          clearQueryCache(['assignment', 'assignments', 'teacherStudents']);
        }}
      />
    </>
  );
};

export default ReturnAssignment;
